import { render, staticRenderFns } from "./LoginDialog.vue?vue&type=template&id=4776a0aa&scoped=true"
import script from "./LoginDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LoginDialog.vue?vue&type=style&index=0&id=4776a0aa&prod&lang=scss&scoped=true"
import style1 from "./LoginDialog.vue?vue&type=style&index=1&id=4776a0aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4776a0aa",
  null
  
)

export default component.exports